var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(this.showSplash)?_c('div',{staticClass:"splash"},[_c('img',{attrs:{"src":"img/splash.gif"}})]):_vm._e(),(!this.showSplash)?_c('div',[_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }